(() => {
  function lineKeysForBundle(bundleKey) {
    const escaped = (window.CSS && CSS.escape) ? CSS.escape(bundleKey) : bundleKey.replace(/"/g, '\\"');
    return Array.from(
      document.querySelectorAll(`[data-bundle-line="${escaped}"]`)
    ).map((el) => el.dataset.bundleLineKey).filter(Boolean);
  }

  async function removeBundle(bundleKey, btn) {
    if (!bundleKey) return;
    if (!confirm('このボックスをカートから削除しますか？')) return;

    const keys = lineKeysForBundle(bundleKey);
    if (keys.length === 0) return;

    const updates = {};
    keys.forEach((k) => { updates[k] = 0; });

    const allButtons = document.querySelectorAll(`[data-bundle-remove="${bundleKey}"]`);
    allButtons.forEach((b) => { b.disabled = true; });

    try {
      const res = await fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ updates }),
      });
      if (!res.ok) {
        const err = await res.json().catch(() => ({}));
        throw new Error(err.description || err.message || 'cart update failed');
      }
      window.location.reload();
    } catch (err) {
      console.error('[BundleCart] remove failed', err);
      alert('削除に失敗しました: ' + err.message);
      allButtons.forEach((b) => { b.disabled = false; });
    }
  }

  function init() {
    document.querySelectorAll('[data-bundle-remove]').forEach((btn) => {
      if (btn.__bundleInited) return;
      btn.__bundleInited = true;
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        removeBundle(btn.dataset.bundleRemove, btn);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
